import segment from 'src/js/modules/analytics/segment';

const iconId = 'feature-icon';

const trackIconSizeResized = ({ blockId, blockVariationId, oldSize, newSize, iconAdjusted }) => {
  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.ICON_SIZE_RESIZED, {
    blockId,
    blockVariationId,
    oldSize,
    newSize,
    iconAdjusted,
    iconId,
  });
};

export default trackIconSizeResized;
